export const DEFAULT_BRANDING_NAME = "CyberSentriq";
export const DEFAULT_BRANDING_LIGHT_LOGO_NAME = "Titan_Logo-UhBGgJ2d.svg";
